import * as sentryTypes from "@sentry/types";
const sentryTypeKeys = ["Severity", "SeverityLevels"];
const wrapSentrySdkKeys = ["init", "onLoad", "addBreadcrumb", "captureEvent", "captureException", "captureMessage", "configureScope", "showReportDialog", "withScope"];
function createSentryClient() {
    const wrappedClient = wrapSentrySdkKeys.reduce((acc, key) => {
        acc[key] = (...args) => {
            if (typeof window === "undefined")
                return;
            if (Object(window.Sentry || {}).hasOwnProperty(key)) {
                window.Sentry[key](...args);
            }
        };
        return acc;
    }, {});
    const types = sentryTypeKeys.reduce((collection, typeKey) => {
        Object.defineProperty(collection, typeKey, {
            value: sentryTypes[typeKey],
            writable: false,
            enumerable: true,
        });
        return collection;
    }, {});
    return Object.freeze({
        ...wrappedClient,
        ...types,
    });
}
export const Sentry = createSentryClient();
//# sourceMappingURL=client.js.map